import axios from 'axios'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

// Resultado é usado apenas dentro do modal de impressão do recibo, por isso não passa pelo reducer
export default function buscarReservasReimpressao (parametros) {
  return () => axios.post(`${URL}/reserva/reservas-reimpressao`, parametros, SLOW_REQUEST_CONFIG)
    .then(response => response.data);
}
